import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Row
} from 'reactstrap';

import FlowButton from "../../../components/flow/PolyFlow/FlowButton";

class IntroFrame extends Component {
    render() {

        const {guarantor_first_name, tenant_full_name, tenant_first_name} = this.props;

        return (
            <div className="mt-4">
                <Row>
                    <h3>Hi {guarantor_first_name}!</h3>
                </Row>
                <hr/>
                <Row>
                    <p>You're here because {tenant_full_name} is applying to a listing through PolyRents. {tenant_first_name} doesn't have enough rental history or income to apply to rental properties independently, so they've listed you as their guarantor. When {tenant_first_name} starts applying to listings, property owners and landlords will require the contact information and the credit report of someone with an established payment history to guarantee that the rent will be paid (that would be you). Once {tenant_first_name} is accepted as a tenant, you may be asked to co-sign on a lease.</p>
                    <p>From here we'll just have you confirm the information {tenant_first_name} has provided about you, verify your identity, and complete a soft credit check with TransUnion. Before you get started, we want to let you know that we take your privacy seriously and never store any of your confidential credit data. Additionally, completing this set of forms for your {tenant_first_name} is not a legal obligation to co-sign a lease. Instead, it's just part of the process that is required for {tenant_first_name} to find their next home.</p>
                    <ul>
                        <li><strong>This is a soft credit check and will not affect your credit score in any way</strong></li>
                        <li><strong>This does not legally compel you to co-sign a lease with or guarantee {tenant_first_name}</strong></li>
                    </ul>
                    <p>If you have any questions on how this process works please or get stuck along the way, please reach out to us via the blue messenger in the bottom right corner of this page.</p>
                </Row>
                <hr/>
                <div className="center">
                    <FlowButton id="guarantorFlow" className="mb-5" color="success" onClick="inc" outline>Let's get Started</FlowButton>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    guarantor_first_name: state.guarantor.first_name,
    tenant_full_name: state.guarantor.tenant.first_name + ' ' + state.guarantor.tenant.last_name,
    tenant_first_name: state.guarantor.tenant.first_name
});

export default connect(mapStateToProps)(IntroFrame);



// WEBPACK FOOTER //
// ./src/containers/guarantor/frames/IntroFrame.js